const customersCount = Number.parseInt(String(process.env.NEXT_PUBLIC_CUSTOMERS_COUNT), 10);

export { customersCount };
